module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABHElEQVRIia3WWxKDIAwF0KTjvmRnN+wsriz9KLG8i9r81AG8RxCcsplRXTHGohEAN4MWi3PAg0MIxSBVvQ2xmZ3BAOg4juFgh3o1wllEDEDTsQLlMx3NchsF7vs+hDw4h7wtWw0uAB8oIn+DAPBW3+T5InoZCiGQqp4gM1sDECEBcRnKX369ETrAOhRjHN+e6jXtNYdAIp/l8yec7bLfQHu4iewLXak+wB/kdCy13ajxDDhJD8LHAPuPPQrvAEJEnZ3ReydXAN9uqoFUQ0Li9+mfLpGIFCewgW6UiJCZ8QaAARAzm3cQ+bEP6dqR9qs7CyfKTrI3rEFr4QVwBZpVHt4FVqArNfnY/Qfi3r+K6Q0VlF/Xy3MLqKFRsNcbqd3SL4a0+60AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/SHUTDOWN.png
// module id = 98
// module chunks = 0